import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';
import { CompanyStaffDto } from '@inosio/payments-sdk';

type PMState = {
  associatedCompanyStaff: { isFetching: boolean; isCompleted: boolean; isError: boolean; staff: CompanyStaffDto[] };
};

const getInitialState = () => {
  return {
    associatedCompanyStaff: { isFetching: false, isCompleted: false, isError: false, staff: [] }
  } as PMState;
};

const pmConfigSettingsSlice = createSlice({
  name: 'pmConfigSettingsReducer',
  initialState: getInitialState(),
  reducers: {
    getPmAssociatedStaff(state) {
      state.associatedCompanyStaff.isFetching = true;
      state.associatedCompanyStaff.isCompleted = false;
      state.associatedCompanyStaff.isError = false;
    },
    setPmAssociatedStaff(state, action) {
      const response = {
        isFetching: false,
        isCompleted: true,
        isError: false,
        staff: action.payload,
      };
      return { ...state, associatedCompanyStaff: response };
    },
  },
});

export const { getPmAssociatedStaff, setPmAssociatedStaff } = pmConfigSettingsSlice.actions;

export default pmConfigSettingsSlice.reducer;
export const selectPmConfigSettingsState = (state: RootState) => state.pmConfigSettingsState;
